module.exports = __webpack_public_path__ + "img/1519227358.7b9e2fd9.jpg";